import {
    Component,
    input,
    computed,
    signal,
    OnInit,
    effect,
    inject,
    ChangeDetectionStrategy
} from '@angular/core';
import { HisBaseGlobalsService } from '../../../../core/service/base/his-base-globals.service';

interface DateSetting {
    value: string;
    defaultValue: string;
    minValue?: Date;
    maxValue?: Date;
    label: string;
    helptext?: string;
    required: boolean;
    readonly: boolean;
    datatype: 'UNRESTRICTED' | 'PAST_DATE' | 'FUTURE_DATE';
    name: string;
}

@Component({
    selector: 'his-date-job-setting',
    templateUrl: './his-date-job-setting.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class HisDateJobSettingComponent implements OnInit {
    setting = input.required<DateSetting>();
    protected minValue = computed(() => this.getMinValue());
    protected maxValue = computed(() => this.getMaxValue());
    protected value = signal<Date | undefined>(undefined);
    private baseGlobalService = inject( HisBaseGlobalsService );
    
    protected title = computed( () => {
        if (this.baseGlobalService.system.operationMode !== 'cust') {
            return '';
        }
        return this.setting().name;
    } );
    
    constructor() {
        effect(() => {
            const localDateTime = this.value();
            if (!localDateTime) {
                this.setting().value = null;
                return;
            }
            // remove time component and adjust for timezone offset
            // see https://stackoverflow.com/a/50130338 for explanation
            const convertedValue = new Date(
                localDateTime.getTime() -
                    localDateTime.getTimezoneOffset() * 60000,
            )
                .toISOString()
                .split('T')[0];

            this.setting().value = convertedValue;
        });
    }

    ngOnInit(): void {
        if (this.setting().defaultValue) {
            this.value.set(new Date(this.setting().defaultValue));
        }
    }

    private getMinValue(): Date | null {
        if (this.setting().datatype === 'FUTURE_DATE') {
            return new Date(
                Math.max(this.setting().minValue?.getTime() || 0, Date.now()),
            );
        }
        return null;
    }
    private getMaxValue(): Date | null {
        if (this.setting().datatype === 'PAST_DATE') {
            return new Date(
                Math.min(
                    this.setting().maxValue?.getTime() ||
                        new Date(1900, 1, 1).getTime(),
                    Date.now(),
                ),
            );
        }
        return null;
    }

}
